const UNAUTHORIZED_CODE = 'UNAUTHORIZED';
export const SIGNATURE_EXPIRED_ERROR_CODE = 8;
const PERMISSION_ERROR_CODE = 54;
const TEST_CREATION_NOT_PERMITTED_ERROR_CODE = 153;

export const getElementaryErrorCode = (error: any) => {
  const data = error?.response?.data;
  if (data === undefined) {
    // in case data is not provided (eg. the graphql-request library doesn't provide access to the error response data),
    // we assume that the error is a signature expired error
    return SIGNATURE_EXPIRED_ERROR_CODE;
  }
  return data?.elementary_error_code;
};

const formatPermissionErrorMessage = (
  objectType?: string,
  objectIds?: string[],
): string => {
  if (!objectType) {
    return 'Change not saved. Edit access required.';
  }

  const lowercaseType = objectType.toLowerCase();
  const isPlural = Array.isArray(objectIds) && objectIds.length > 1;
  const displayType = isPlural ? `${lowercaseType}s` : lowercaseType;

  return `Changes not saved. You don't have permission to edit the selected ${displayType}.`;
};

export const getPermissionErrorMessage = (error: any): string | null => {
  const elementaryErrorCode = getElementaryErrorCode(error);

  if (elementaryErrorCode === TEST_CREATION_NOT_PERMITTED_ERROR_CODE) {
    return (
      error?.response?.data?.error_message ||
      "Cannot create test: you don't have edit access to the resulting resource group."
    );
  }

  if (elementaryErrorCode === PERMISSION_ERROR_CODE) {
    const extra = error?.response?.data?.extra;
    return formatPermissionErrorMessage(extra?.object_type, extra?.object_ids);
  }

  const graphqlErrors = error?.response?.errors;
  if (Array.isArray(graphqlErrors)) {
    for (const gqlError of graphqlErrors) {
      if (gqlError?.extensions?.code === UNAUTHORIZED_CODE) {
        return formatPermissionErrorMessage(
          gqlError?.extensions?.object_type,
          gqlError?.extensions?.object_ids,
        );
      }
    }
  }

  return null;
};
